import { Controller } from "@hotwired/stimulus"

// Форма лічильника: підстановка одиниці за замовчуванням від послуги (якщо поле
// порожнє або дорівнює дефолту попередньої послуги) і показ залежного селекта
// прив'язки (офіс / контрагент / будівля).
export default class extends Controller {
  static targets = ["service", "unit", "officeSelect", "counterpartySelect", "buildingRole"]

  connect() {
    if (this.hasServiceTarget) {
      this.previousDefault = this.currentServiceDefault()
    }
    this.syncOwner()
  }

  serviceChanged() {
    if (!this.hasUnitTarget) return
    const newDefault = this.currentServiceDefault()
    const current = this.unitTarget.value.trim()
    if (current === "" || current === this.previousDefault) {
      this.unitTarget.value = newDefault
    }
    this.previousDefault = newDefault
  }

  ownerChanged() {
    this.syncOwner()
  }

  syncOwner() {
    const kind = this.selectedOwnerKind()
    if (this.hasOfficeSelectTarget) {
      this.officeSelectTarget.hidden = kind !== "office"
    }
    if (this.hasCounterpartySelectTarget) {
      this.counterpartySelectTarget.hidden = kind !== "counterparty"
    }
    if (this.hasBuildingRoleTarget) {
      this.buildingRoleTarget.hidden = kind !== "building"
    }
  }

  currentServiceDefault() {
    const option = this.serviceTarget.options[this.serviceTarget.selectedIndex]
    return (option && option.dataset.unit) || ""
  }

  selectedOwnerKind() {
    const checked = this.element.querySelector('input[name="meter[owner_kind]"]:checked')
    return checked ? checked.value : "building"
  }
}
